import { Trans } from '@ui/i18n/trans';
import { Product } from '../product';
import { CheckIcon } from '@ui/icons/material/Check';
import { CheckCircleOutlineIcon } from '@ui/icons/material/CheckCircleOutline';

interface FeatureListProps {
  product: Product;
}

export function ProductFeatureList({ product }: FeatureListProps) {
  if (!product.feature_list.length) return null;

  return (
    <div className="mt-24 border-t pt-24">
      <div className="mb-10 text-lg font-semibold">
        <Trans message="What's included" />
      </div>
      {product.feature_list.map(feature => (
        <div key={feature} className="flex items-center gap-10 py-6 text-sm">
          <CheckCircleOutlineIcon color='green' size="sm" />
          <Trans message={feature} />
        </div>
      ))}
    </div>
  );
}
